export default __webpack_public_path__ + "static/media/expresscomputer.af027aa5.webp";